import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  useDisclosure,
  VStack,
  Image,
  Text,
  Select,
} from "@chakra-ui/react";
import {
  REQUEST_MASTER_HELP_CENTER,
  REQUEST_MASTER_HELP_CENTER_CATEGORIES,
} from "../../store/helpcenter/helpcenterActionTypes";
import { useHelpcenterMaster } from "../../store/helpcenter/reducer";
import HelpcenterMasterTable from "../../components/HelpcenterMasterTable/HelpcenterMasterTable";

// eslint-disable-next-line react-hooks/rules-of-hooks
interface Props {
  query?: string;
}
const Helpcenter: React.FC<Props> = ({ query }) => {
  // const { masterHELP_CENTERCat, busy, masterHELP_CENTER } =
  //   useHelpcenterMaster();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: REQUEST_MASTER_HELP_CENTER });
    dispatch({ type: REQUEST_MASTER_HELP_CENTER_CATEGORIES });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchQuery, setSearch] = useState("");
  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Helpcenter
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <HelpcenterMasterTable query={searchQuery} />
    </>
  );
};

export default Helpcenter;
